import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    Tooltip,
    CircularProgress
} from '@mui/material';
import HeaderAvatar from "./HeaderAvatar";
import {
    addScaenario,
    addVisit,
    deleteVisit,
    fetchPresentation,
    updatePresentation,
    updateScenario,
    fetchPresentations,
    updateVisit,
    getVisits,
    uploadPresentationArchive,
    uploadProjectVideo, updateProject
    // addVisit,
    // addSlideToVisit,
    // createVideoFolder,
    // getVisits,
    // getSlides,
    // processProject,
    // editVisitName,
    // reorderVisitSlides,
    // updateSlide, fetchProjects, deleteVisit
} from '../services/api';
import Icon from "./Icon";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragEndEvent } from '@dnd-kit/core';
import VisitBox from '../components/VisitBox';
// import { deleteVisitSlide } from '../services/api';
import {DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import {
    Add
} from '@mui/icons-material';
import {Link, LinkEdit, Presentation, Project, Scenario, Slide, Visit} from '../services/types'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SlideEditModal from '../components/SlideEditModal'
import { SelectChangeEvent } from '@mui/material/Select';
import LinkEditModal from "./LinkEditModal";
import projects from "../pages/Projects";

// interface VisitSlide {
//     id: string;
//     slide: Slide;
// }
// interface Visit {
//     id: string;
//     name: string;
//     project_id: string;
//     sort: number;
//     external_id?: string;
//     slides: VisitSlide[];
// }
interface ProjectEditorProps {
    project: Project;
    onUpload: (file: File) => Promise<void>;
    updateProjectData: (project: Project) => void;
}
// interface Presentation {
//     id: string;
//     name: string;
//     photo_url: string;
//     clm_type_id: string;
//     // Add other properties as needed
// }

// interface VisitBoxProps {
//     visit: Visit;
//     onAddSlide: (visitId: string) => void;
// }
// interface SortableSlideItemProps {
//     slide: VisitSlide;
// }

function getSlidesIds(data: any): number[] {
    if (!data.slides || !Array.isArray(data.slides)) {
        return [];
    }
    return data.slides.map((slide: any) => slide.id);
}
function getVisitById(list: any[], id: number) {
    return list.find((visit: { id: any; }) => visit.id === id);
}
function getVisitIds(data: any): number[] {
    if (!data.visites || !Array.isArray(data.visites)) {
        return [];
    }
    return data.visites.map((visit: any) => visit.id);
}
function getPresentationById(list: any[], id: string) {
    return list.find((presentation: { id: any; }) => presentation.id === id);
}
const ProjectEditor: React.FC<ProjectEditorProps> = ({ project, onUpload, updateProjectData }) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [currentProject, setCurrentProject] = useState<Project | null>(null);

    const handleSave = async () => {
        try {
            var project_video_id: number | null = null
            if (project.video != null){
                project_video_id = project.video.id
            }
            const startDate = new Date(currentProject?.startDate!!);
            const endDate = new Date(currentProject?.endDate!!);
            const updateData = {
                status: currentProject?.status,
                title: currentProject?.title,
                description: currentProject?.description,
                videoId: project_video_id,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                multipleSessionWriteCount: currentProject?.multipleSessionWriteCount,
                multipleSessionAvailableCount: currentProject?.multipleSessionAvailableCount,
                subtitles: currentProject?.subtitles
            }
            await updateProject(currentProject?.id, updateData);
            // updateScenarioData(currentScenario!!)
        } catch (error) {
            console.error('Error inviting team member:', error)
        }
    };

    useEffect(() => {
        setCurrentProject(project)
    }, [project.id]);
    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            onUpload(file);
        }
    };


    return (
        <Box display="flex" sx={{height: 'calc(100vh - 64px)'}}>
            <Box sx={{display: 'flex', flexDirection: 'column', width: '384px', height: '100%', background: '#3a485b36', boxSizing: 'border-box'}}>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept=".video/mp4"
                />
                <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', height: '50px', borderBottom: '#fff3 solid 1px'}} onClick={handleUploadClick}><Icon name="upload"/>&nbsp;Загрузить видео</Button>
                <Box sx={{padding: '10px 20px'}}>
                    <Typography sx={{mb: 2, mt: 1, fontWeight: 'bold'}}>ID проекта: {currentProject?.id}</Typography>

                    <TextField
                        fullWidth
                        margin="normal"
                        label="Название"
                        value={currentProject?.title}
                        onChange={(e) => {
                            setCurrentProject({
                                ...currentProject!!,
                                title: e.target.value
                            });
                        }}
                        multiline
                        rows={1}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Описание"
                        value={currentProject?.description}
                        onChange={(e) => {
                            setCurrentProject({
                                ...currentProject!!,
                                description: e.target.value
                            });
                        }}
                        multiline
                        rows={4}
                    />
                    {currentProject?.status != null && (
                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                        <InputLabel id="project-select-label">Статус проекта</InputLabel>
                        <Select
                            labelId="project-select-label"
                            id="project-select"
                            value={currentProject?.status}
                            label="Статус проекта"
                            onChange={(e) => {
                                setCurrentProject({
                                    ...currentProject!!,
                                    status: e.target.value
                                });
                            }}
                        >
                            <MenuItem key="MODERATE" value={"MODERATE"}>
                                На модерации
                            </MenuItem>
                            <MenuItem key="ACTIVE" value={"ACTIVE"}>
                                Активен
                            </MenuItem>
                        </Select>
                    </FormControl>
                    )}
                    <TextField
                        label="Дата начала"
                        type="datetime-local"
                        value={currentProject?.startDate?.slice(0, 16) || ''}
                        onChange={(e) => setCurrentProject({
                            ...currentProject!!,
                            startDate: e.target.value
                        })}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        label="Дата окончания"
                        type="datetime-local"
                        value={currentProject?.endDate?.slice(0, 16) || ''}
                        onChange={(e) => setCurrentProject({
                            ...currentProject!!,
                            endDate: e.target.value
                        })}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Сколько раз можно посмотреть"
                        type="number"
                        value={currentProject?.multipleSessionAvailableCount || 0}
                        onChange={(e) => setCurrentProject({
                            ...currentProject!!,
                            multipleSessionAvailableCount: Number(e.target.value)
                        })}
                        fullWidth
                        margin="normal"
                    />

                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                        <InputLabel id="project-select-label">Записывать ли статистику при повторе</InputLabel>
                        <Select
                            labelId="project-select-label"
                            id="project-select"
                            value={currentProject?.multipleSessionWriteCount || 0}
                            label="Записывать ли статистику при повторе"
                            onChange={(e) => setCurrentProject({
                                ...currentProject!!,
                                multipleSessionWriteCount: Number(e.target.value)
                            })}
                        >
                            <MenuItem key="YES" value={1}>
                                Да
                            </MenuItem>
                            <MenuItem key="NO" value={0}>
                                Нет
                            </MenuItem>
                        </Select>
                    </FormControl>

                    <Button onClick={handleSave} variant="contained" sx={{mt: 2, background:'#3a485b', width: '100%'}}>
                        Сохранить
                    </Button>
                </Box>
            </Box>
            <Box sx={{width: 'calc(100% - 384px)', height: 'calc(100% - 64px)', position: 'absolute', right: 0, overflowX: 'hidden', overflowY: 'scroll'}}>
                <Box sx={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {project.video == null ?
                        <Box>
                        Видео отсутствует...
                        </Box>
                     :
                        <video src={'https://stage.selfdetailing.ru'+project.video.raw} controls={true} style={{width: '100%', height: '100%', objectFit: 'contain'}}></video>
                    }

                </Box>
            </Box>

        </Box>
    );
};
export default ProjectEditor;
